import { ChangeDetectorRef, Component, DestroyRef, Input, Optional } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { select, Store } from '@ngrx/store';

import { AbilitiesSelectors } from '@recruitee/abilities-data';
import { Ability } from '@recruitee/abilities-types';
import { DevFlag, injectDevFlag } from '@recruitee/dev-flags-data';
import { OfferAnalytics } from '@recruitee/offers';
import { StatusChangeType } from '@recruitee/offers-data';
import type { OfferItem } from '@recruitee/offers-types';

import { OfferActionsFacade } from '../facades/offer-actions-facade.types';
import { ActionsDropdownComponent } from '../offers-page/actions-dropdown/actions-dropdown.component';

@Component({
  selector: 'rt-actions-dropdown-container',
  template: `
    <rt-actions-dropdown
      [offer]="offer"
      [type]="type"
      [hasNewJobEditorFeature]="hasNewJobEditorFeature"
      [canManageJobs]="abilities.manageJobs"
      [canViewAcquisition]="abilities.viewAcquisition"
      (action)="action($event)"
      (trackPreview)="trackPreview()"
    ></rt-actions-dropdown>
  `,
  standalone: true,
  imports: [ActionsDropdownComponent],
})
export class ActionsDropdownContainerComponent {
  @Input() public offer: OfferItem;
  @Input() public type: 'table' | 'list';

  public abilities = {
    manageJobs: false,
    viewAcquisition: false,
  };
  public hasNewJobEditorFeature = injectDevFlag(DevFlag.NewJobEditor);

  constructor(
    private destroyRef: DestroyRef,
    private cdRef: ChangeDetectorRef,
    private store: Store,
    private actionsFacade: OfferActionsFacade,
    @Optional() private offerAnalytics: OfferAnalytics,
  ) {}

  public ngOnInit() {
    this.store
      .pipe(select(AbilitiesSelectors.abilityMap), takeUntilDestroyed(this.destroyRef))
      .subscribe(enabledMap => {
        this.abilities = {
          manageJobs: enabledMap[Ability.ManageJobs],
          viewAcquisition: enabledMap[Ability.ViewAcquisition],
        };
        this.cdRef.detectChanges();
      });
  }

  public action(name: StatusChangeType): void {
    switch (name) {
      case StatusChangeType.Duplicate:
        this.actionsFacade.duplicate(this.offer);
        break;
      case StatusChangeType.Archive:
        this.actionsFacade.archive(this.offer);
        break;
      case StatusChangeType.Unarchive:
        this.actionsFacade.retrieve(this.offer);
        break;
      case StatusChangeType.Delete:
        this.actionsFacade.delete(this.offer);
        break;
      default:
        break;
    }
    return;
  }

  public trackPreview(): void {
    if (this.offerAnalytics.trackPreviewJob) {
      this.offerAnalytics.trackPreviewJob();
    }
  }
}
